import { CSSProperties, FC, ReactNode } from 'react'
import { Inline } from '@shared/layout/Inline'
import { NavigationArrow } from '@ui/NavigationArrow'
import { useIonRouter } from '@ionic/react'
import { ROUTES } from '@shared/constants/routes'

interface ArrowHeaderProps {
	backPath?: string
	goBackFunction?: () => void
	children?: ReactNode
	className?: string
	style?: CSSProperties
	centeredChildren?: boolean
	color?: 'white' | 'black'
	isArrowBackground?: boolean
	arrowClassName?: string
	arrowStyle?: CSSProperties
}

export const BackArrowHeader: FC<ArrowHeaderProps> = ({
	backPath = ROUTES.overall.main,
	className,
	style,
	children,
	goBackFunction,
	centeredChildren = false,
	color = 'black',
	isArrowBackground,
	arrowClassName,
	arrowStyle,
}) => {
	const nav = useIonRouter()
	const handleClick = () => {
		if (goBackFunction) {
			goBackFunction()
			return
		}

		if (nav.canGoBack()) {
			nav.goBack()
			return
		}

		nav.push(backPath, 'back', 'replace')
	}

	if (!centeredChildren) {
		return (
			<Inline
				className={className}
				style={{ width: '100%', ...style }}
				align={'center'}
				gap={28}>
				<NavigationArrow
					className={arrowClassName}
					color={color}
					direction={'left'}
					onClick={handleClick}
					style={arrowStyle}
				/>
				{children}
			</Inline>
		)
	}

	const arrowBackgroundStyles = isArrowBackground
		? { backgroundColor: 'white', borderRadius: 1000 }
		: undefined

	return (
		<Inline
			className={className}
			style={{ width: '100%', ...style }}
			align={'center'}
			gap={28}>
			<div
				style={{
					alignItems: 'center',
					flex: 1,
					display: 'flex',
					justifyContent: 'center',
					position: 'relative',
				}}>
				<NavigationArrow
					className={arrowClassName}
					color={color}
					direction={'left'}
					onClick={handleClick}
					style={{
						position: 'absolute',
						left: 0,
						marginLeft: 16,
						...arrowBackgroundStyles,
						...arrowStyle,
					}}
				/>
				<div style={{ display: 'flex', justifyContent: 'center', width: '100%' }}>
					{children}
				</div>
			</div>
		</Inline>
	)
}
